<ng-container *ngIf="manager">
  <div class="manager-container">
    <div class="block-photo">
      <img class="photo" [src]="manager.photo" />
    </div>
    <div class="block-manager-info">
      <div class="manager-title">{{ manager.fullName }}</div>
      <div class="manager-subtitle">Личный менеджер</div>
      <div class="manager-fields-wrapper">
        <div *ngIf="manager.department" class="manager-field manager-field--sm">{{ manager.department }}</div>
        <div *ngIf="manager.phone" class="manager-field manager-field--lg">
          <a target="_blank" href="https://wa.me/{{ manager.phone }}">
            <cx-icon type="WHATSAPP"></cx-icon>
            <span class="number">{{ manager.phone }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="block-buttons">
      <ng-container *ngIf="!manager.confirmed">
        <ng-content></ng-content>
      </ng-container>
    </div>
  </div>
</ng-container>
